import update from 'immutability-helper';
import { AnyAction, Dispatch } from 'redux';

import {
  deleteContact as doDeleteContact,
  loadContacts as doLoadContacts,
  saveContacts as doSaveContacts,
  updateContacts as doUpdateContacts,
} from '../services/contacts';

// Actions
const START_LOAD = 'haulerProfile/contacts/START_LOAD';
const COMPLETE_LOAD = 'haulerProfile/contacts/COMPLETE_LOAD';
const FAIL_LOAD = 'haulerProfile/contacts/FAIL_LOAD';
const START_SAVE = 'haulerProfile/contacts/START_SAVE';
const COMPLETE_SAVE = 'haulerProfile/contacts/COMPLETE_SAVE';
const FAIL_SAVE = 'haulerProfile/contacts/FAIL_SAVE';
const START_UPDATE = 'haulerProfile/contacts/START_UPDATE';
const COMPLETE_UPDATE = 'haulerProfile/contacts/COMPLETE_UPDATE';
const FAIL_UPDATE = 'haulerProfile/contacts/FAIL_UPDATE';
const START_DELETE = 'haulerProfile/contacts/START_DELETE';
const COMPLETE_DELETE = 'haulerProfile/contacts/COMPLETE_DELETE';
const FAIL_DELETE = 'haulerProfile/contacts/FAIL_DELETE';
const RESET = 'haulerProfile/contacts/RESET';

// Initial state
const initialState = {
  isDeleting: false,
  isLoading: false,
  isSaving: false,
  isUpdating: false,
  contacts: undefined,
  functionTypes: undefined,
};

// Reducer
export const reducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case START_LOAD:
      return update(state, {
        $merge: {
          isLoading: true,
        },
      });

    case COMPLETE_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          contacts: action.contacts.contacts,
          functionTypes: action.contacts.allContactFunctionTypes,
        },
      });

    case FAIL_LOAD:
      return update(state, {
        $merge: initialState,
      });

    case START_SAVE:
      return update(state, {
        $merge: {
          isSaving: true,
        },
      });

    case COMPLETE_SAVE:
      return update(state, {
        $merge: {
          isSaving: false,
        },
      });

    case FAIL_SAVE:
      return update(state, {
        $merge: {
          isSaving: false,
        },
      });

    case START_UPDATE:
      return update(state, {
        $merge: {
          isUpdating: true,
        },
      });

    case COMPLETE_UPDATE:
      return update(state, {
        $merge: {
          isUpdating: false,
        },
      });

    case FAIL_UPDATE:
      return update(state, {
        $merge: {
          isUpdating: false,
        },
      });

    case START_DELETE:
      return update(state, {
        $merge: {
          isDeleting: true,
        },
      });

    case COMPLETE_DELETE:
      return update(state, {
        $merge: { isDeleting: false },
      });

    case FAIL_DELETE:
      return update(state, {
        $merge: {
          isDeleting: false,
        },
      });

    case RESET:
      return update(state, {
        $merge: initialState,
      });

    default:
      return state;
  }
};

// Action creators
const startLoad = () => ({
  type: START_LOAD,
});

const completeLoad = (contacts: any) => ({
  type: COMPLETE_LOAD,
  contacts,
});

const failLoad = () => ({
  type: FAIL_LOAD,
});

const startSave = () => ({
  type: START_SAVE,
});

const completeSave = () => ({
  type: COMPLETE_SAVE,
});

const failSave = () => ({
  type: FAIL_SAVE,
});

const startUpdate = () => ({ type: START_UPDATE });

const completeUpdate = () => ({ type: COMPLETE_UPDATE });

const failUpdate = () => ({ type: FAIL_UPDATE });

const startDelete = () => ({
  type: START_DELETE,
});

const completeDelete = () => ({
  type: COMPLETE_DELETE,
});

const failDelete = () => ({ type: FAIL_DELETE });

export const loadContacts = (haulerId: string, contactType: string, divisionId: string) => (dispatch: Dispatch) => {
  dispatch(startLoad());
  const loadContactsPromise = doLoadContacts(haulerId, contactType, divisionId);
  loadContactsPromise.then(contacts => dispatch(completeLoad(contacts))).catch(() => dispatch(failLoad()));
  return loadContactsPromise;
};

export const saveContacts = (haulerId: string, data: any) => (dispatch: Dispatch) => {
  dispatch(startSave());
  const saveContactPromise = doSaveContacts(haulerId, data);
  saveContactPromise.then(() => dispatch(completeSave())).catch(() => dispatch(failSave()));
  return saveContactPromise;
};

export const updateContacts = (haulerId: string, data: any) => (dispatch: Dispatch) => {
  dispatch(startUpdate());
  const updateContactPromise = doUpdateContacts(haulerId, data);
  updateContactPromise.then(() => dispatch(completeUpdate())).catch(() => dispatch(failUpdate()));
  return updateContactPromise;
};

export const deleteContact = (haulerId: string, contactId: number, divisionId: string) => (dispatch: Dispatch) => {
  dispatch(startDelete());
  const deleteContactPromise = doDeleteContact(haulerId, contactId, divisionId);
  deleteContactPromise.then(() => dispatch(completeDelete())).catch(() => dispatch(failDelete()));
  return deleteContactPromise;
};

export const resetContacts = () => ({
  type: RESET,
});
